"use client";

import { useSyncExternalStore } from "react";

// Nothing to subscribe to: the value changes exactly once, from the server
// snapshot to the client one, and React makes that switch itself.
function subscribe(): () => void {
  return () => {};
}
function getSnapshot(): boolean {
  return true;
}
function getServerSnapshot(): boolean {
  return false;
}

/**
 * `false` on the server and during the calling component's hydration render,
 * `true` from the render React performs right after it.
 *
 * Inside a Suspense boundary (every route with a `loading.tsx`) that is later
 * than the root's hydration, so it tells you when THIS subtree is interactive.
 * `FunnelShell` exposes it as `data-hydrated`, which the e2e helpers wait for
 * before typing into server-rendered inputs.
 */
export function useIsHydrated() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}